module.exports = __webpack_public_path__ + "img/bebe-picot.08eefc52.jpg";